export * from 'multiformats/link'
export { base32 } from 'multiformats/bases/base32'
export { base58btc } from 'multiformats/bases/base58'
